export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6790.71032338.jpg";